import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        console.log("Popover controller connected")
        let options = {
            html: true,
            trigger: this.element.getAttribute('trigger') || 'hover',
            placement: this.element.getAttribute('placement') || 'top'
        }
        $(this.element).popover()
    }
}
